import clsx from 'clsx';

import { Back } from './Back';
import { Link } from '../Link';
import { useIsMobile } from '../../hooks';

type BreadcrumbsProps = {
  title: string;
  subtitle: string;
  subtitleUrl: string;
  className?: string;
};

const DesktopBreadcrumbs: React.FC<BreadcrumbsProps> = ({
  title,
  className,
  subtitle,
  subtitleUrl,
}) => {
  return (
    <div
      className={clsx(
        className,
        'flex flex-row items-center gap-x-xs text-small'
      )}
    >
      <Link
        url={subtitleUrl}
        withDecoration
        defaultClassName="text-secondary cursor-pointer pr-xs pl-0"
      >
        {subtitle}
      </Link>
      <span>/</span>
      <Link
        url="#"
        withDecoration
        defaultClassName="text-main cursor-pointer font-medium px-xs"
      >
        {title}
      </Link>
    </div>
  );
};

const MobileBreadcrumbs: React.FC<BreadcrumbsProps> = ({
  title,
  className,
  subtitleUrl,
}) => {
  return (
    <div
      className={clsx(
        className,
        'flex flex-row items-center gap-x-xs text-small'
      )}
    >
      {!!subtitleUrl && (
        <Link
          url={subtitleUrl}
          withDecoration={false}
          defaultClassName="text-secondary cursor-pointer pr-xs pl-0"
        >
          <Back />
        </Link>
      )}
      <Link
        url="#"
        withDecoration={false}
        defaultClassName="cursor-pointer font-semibold px-xs"
      >
        {title}
      </Link>
    </div>
  );
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = props => {
  const Component = useIsMobile() ? MobileBreadcrumbs : DesktopBreadcrumbs;

  return <Component {...props} />;
};
